<template>
<span>
    <pakhsh-muyragi-details></pakhsh-muyragi-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import PakhshMuyragiDetails from '@/components/moduls/PakhshMuyragiDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'pakhshmuyragi',
    components:{
        PakhshMuyragiDetails,
        PageFooter
    }

    
};
</script>


